import { Turnstile } from "@marsidev/react-turnstile";
import { Notice } from "./Notice";

const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;

export function TurnstileField({
  enabled,
  onToken,
}: {
  enabled: boolean;
  onToken: (token: string | undefined) => void;
}) {
  if (!enabled) {
    return null;
  }

  if (!siteKey) {
    return (
      <Notice compact title="Bot check not configured" tone="warning">
        Cloud publish will run without Turnstile until VITE_TURNSTILE_SITE_KEY is set.
      </Notice>
    );
  }

  return (
    <div className="rounded-card border border-border bg-surface-raised p-3">
      <Turnstile
        options={{ theme: "auto" }}
        siteKey={siteKey}
        onError={() => onToken(undefined)}
        onExpire={() => onToken(undefined)}
        onSuccess={(token) => onToken(token)}
      />
    </div>
  );
}
